<template>
<div>
    <div class="breadcrumbs" id="breadcrumbs">
        <span class="breadcrumb-link">Preferences</span> &gt;
        <router-link class="breadcrumb-link" to="/settings">Your Account</router-link>
    </div>
    <h3>User Account Settings</h3>

    <div class="large-form">
      <h4>Basic Settings</h4>
      <div class="form-line">
          <div class="form-line-fields mobile-second">
              <div id="form-field-name" class="form-field">
                  <label for="name">Your Name</label>
                  <input v-model="user.name" type="text" name="name" required="required"  />
              </div>
          </div>
          <div class="form-line-desc mobile-first">You can change your personal user account settings here. To change your email, please contact us.</div>
      </div>

      <div class="form-line">
          <div class="form-line-fields">
              <div id="form-field-email" style="width: 45%"  class="form-field">
                  <label for="name">Your Email</label>
                  <div class="form-static-field">{{ user.email }}</div>
              </div>
            <div id="form-field-role" style="width: 30%" class="form-field">
                <label for="name">Your Role</label>
                <div class="form-static-field"><b>{{ fullRoleName(user.role) }}</b></div>
            </div>
          </div>
      </div>

      <div class="form-line">
          <div class="form-line-fields">
              <div id="form-field-password" class="form-field">
                  <label for="name">New Password</label>
                  <input v-model="user.password" type="password" name="password" required="required"  />
              </div>
              <div id="form-field-password" class="form-field">
                  <label for="name">Confirm Password</label>
                  <input v-model="user.passwordConfirm" type="password" name="password" required="required"  />
              </div>
          </div>
      </div>
      <div class="form-errors">
          <p v-for="e in userErrors" class="form-field error-text"><span v-html="e[0]"></span></p>
      </div>

      <div @click="updateUserSettings" class="ws-button ws-button-primary">Update User Settings</div>

    </div>

    <div v-if="!demo.isDemo && team.plan=='pro'" class="large-form">
        <h4 v-if="!demo.isDemo && team.plan=='pro'">E-Mail Preferences</h4>
        <div class="form-line">
            <div class="form-line-fields">
              <label for="form-input-approve">Your E-Mail Preferences</label>
                <div class="form-field form-field-checkbox" v-for="emailType in emailCategories" >
                  <input type="checkbox" name="email-type" v-model="user.email_preferences" :value="emailType.type">
                  <span class="checkbox-label">{{ emailType.label }}</span>
                </div>

            </div>
            <div class="form-line-desc">Choose types of email updates that you would like to receive.</div>
        </div>
        <div @click="updateUserSettings" class="ws-button ws-button-primary">Update User Settings</div>
    </div>

    <div v-if="user.permissions && user.permissions.includes('use-cards')">
        <div class="large-form">
            <h4>Direct Payment Methods</h4>
            <div class="form-line" v-if="paymentMethodsLoaded">
                <div class="form-line-fields">
                    <div v-if="stripePaymentMethods.length" class="form-field">
                        <label>Payment Cards</label>
                        <table id="payment-cards" class="worksends-table inset">
                            <thead>
                            <tr>
                                <th>Payment Card</th>
                                <th>Expiry Date</th>
                                <th class="field-actions">Actions</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in stripePaymentMethods">
                                <td class="field-name"><div class="value"><span class="brand">{{ item.card_brand }}</span> ending in {{ item.last4 }} <span class="preferred" v-if="item.preferred"> - Preferred</span></div></td>
                                <td class="field-date"><div class="value">{{ item.exp_month}}/{{ item.exp_year }}</div></td>
                                <td class="field-actions"><div class="value">
                                    <a class="ws-button small" :class="{ disabled: item.preferred }" @click.prevent="preferPaymentMethod(item)" v-tooltip="item.preferred?'This is already your preferred payment method.':'Make this your preferred payment method.'">Make Preferred</a>
                                    <a class="ws-button ws-button-negative small" :class="{ disabled: item.preferred && stripePaymentMethods.length > 1 }" v-tooltip="(item.preferred && stripePaymentMethods.length > 1)?'To remove this method, make different one preferred or add a new one first.':'Delete this payment method.'" @click.prevent="detachPaymentMethod(item)">Remove</a>
                                </div></td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="small-note error"><b>You don't have any direct payment method associated with your account.</b><br />You can use these these payment cards to pay for campaign sends costs and marketplace costs directly, instead of relying only on your team's credit.</div>
                </div>
                <div class="form-line-desc" v-if="stripePaymentMethods.length">
                    <p>These are payment cards currently associated with your account. Each user within your team has their own list of associated payment cards.</p>
                    <p>You can use these these payment cards to pay for campaign sends costs and marketplace costs directly, instead of relying only on your team's credit.</p>
                </div>
            </div>
          <div @click="addPaymentMethod" class="ws-button ws-button-primary">Add New Payment Card</div>
        </div>
    </div>

    <payment-method-modal v-if="modals.paymentMethodModal"></payment-method-modal>
</div>
</template>

<script>
import PaymentMethodModal from '@/components/modals/PaymentMethodModal';

export default {
    name: "SettingsPage",
    components: {PaymentMethodModal},
    data() {
        return {
            userErrors: {},
            paymentMethodsLoaded: false,
            editUserId: null,
        }
    },
    methods: {
        async fetchData() {
            if (!this.demo.isDemo) await this.dispatchWaitAndNotify('fetchStripePaymentMethods', null, false, true);
            this.paymentMethodsLoaded = true;
        },
        addPaymentMethod() {
            if (!this.demoCheck()) return;
            this.modals.paymentMethodModal = true;
        },
        async detachPaymentMethod(item) {
            if (!this.demoCheck()) return;
            if (this.stripePaymentMethods.length == 1) {
                if (!confirm('Are you sure you want to delete your last active payment method? You will be unable to use direct payments and some services may become unavailable.')) {
                    return;
                }
            }
            await this.dispatchWaitAndNotify('detachStripePaymentMethod', item.id);
        },
        async preferPaymentMethod(item) {
            if (!this.demoCheck()) return;
            await this.dispatchWaitAndNotify('preferStripePaymentMethod', item.id);
        },
        updateUserSettings() {
            if (!this.demoCheck()) return;
            
            this.userErrors = this.validateFields([
                { name: 'Name', value: this.user.name, rules: ['required', 'minLength:1'] },
                { name: 'Password', value: this.user.passwordConfirm, rules: ['minLengthIf:6'] },
                { name: 'Password confirmation', value: this.user.passwordConfirm, rules: ['minLengthIf:6',['mustMatch',this.user.password]] },
            ])
            if (Object.keys(this.userErrors).length) return;
            this.dispatchWaitAndNotify('updateCurrentUser', this.user);
        },
        fullRoleName(name) {
            if (name=='manager') return 'Team Manager';
            else if (name=='associate') return 'Team Associate';
            else if (name=='bb_admin') return 'BB HUB Account Manager';
            else return name;
        },
        isEmailTypeActive(type) {
          if (this.user.email_preferences && this.user.email_preferences.includes(type.type)) return true;
          else return false;
        }
    },
    mounted() {
        this.fetchData();
    },
    computed: {
        demo() {
            return this.$store.state.demo;
        },
        team() {
            return this.$store.state.team.detail;
        },
        user() {
            return this.$store.state.currentUser;
        },
        emailCategories() {
            return this.$store.state.emailCategories;
        },
        modals() {
            return this.$store.state.modals;
        },
        stripePaymentMethods() {
            return this.$store.state.transaction.stripePaymentMethods;
        }
    }
}
</script>
